import React, { useEffect, useState } from 'react';
import { CBadge, CButton, CCard, CCardBody, CCardFooter, CCol, CForm, CFormLabel, CRow } from '@coreui/react';
import Select from 'react-select';

import { useLocation, useNavigate } from 'react-router-dom';
import { createRefunds, deleteRefunds, updateRefunds } from 'src/services/Refunds';
import { CFormInput, CHeader } from '@coreui/react';
import { Toaster } from 'src/components/Toaster';
import { format } from 'date-fns';
import { getBoothsById, getBoothsForBranch, getBranchById } from 'src/services/Booths/Booths';
export default function RefundActions() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentDate = new Date();
  const [isEdit, setIsEdit] = useState(false);
  const formattedCurrentDate = format(currentDate, 'yyyy-MM-dd');
  const [props, setProps] = useState(location.state?.item ? [location.state.item] : []);

  const [transactionDate, setTransactionDate] = useState(
    location.state?.item?.rawTransactionDate ?? formattedCurrentDate
  );
  const [refundDate, setRefundDate] = useState(location.state?.item?.rawRefundDate ?? formattedCurrentDate);
  const [amount, setAmount] = useState(location.state?.item?.rawAmount ?? 0);
  const [notes, setNotes] = useState(location.state?.item?.notes ?? '');
  const [selectedBooth, setSelectedBooth] = useState(
    location.state?.item
      ? {
          id: location.state.item.boothID,
          label: `${location.state.item.merchantName} - ${location.state.item.boothID}`,
          value: location.state.item.boothID
        }
      : { id: '999', label: 'Not Loaded', value: 'not' }
  );
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const [boothOptions, setBoothOptions] = useState([]);

  // function testSnackBar(){
  //   setMessage("test")
  //   setOpen(true)
  // }
  useEffect(() => {
    if (location?.state?.item != null) {
      setIsEdit(true);
    }
    fetchBooths();
  }, [props]);
  const fetchBooths = async () => {
    let response = await getBoothsForBranch();

    if (response.success === 1) {
      let data =
        response?.data.map((item) => {
          return {
            id: item.id,
            label: `${item.name} - ${item.id}`,
            value: item.id
          };
        }) ?? [];

      if (selectedBooth.id === '999' && !isEdit) {
        setSelectedBooth(data[0]);
      }

      setBoothOptions(data);
    }
  };
  async function handleOnClick(action) {
    if (action === 'Update') {
      const data = {
        id: props[0].id,
        boothID: selectedBooth.id,
        transactionDate: transactionDate,
        refundDate: refundDate,
        amount: amount,
        notes: notes
      };

      const update = await updateRefunds(data);

      if (update.success === 1) {
        setMessage(update.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(update.message);
        setOpen(true);
        setColor('red');
      }
    } else {
      const data = {
        boothID: selectedBooth.id,
        transactionDate: transactionDate,
        refundDate: refundDate,
        amount: amount,
        notes: notes
      };
      const update = await createRefunds(data);

      if (update.success === 1) {
        setMessage(update.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(update.message);
        setOpen(true);
        setColor('red');
      }
    }
  }

  async function handleDelete() {
    const data = {
      id: props[0].id
    };

    const deleteRefund = await deleteRefunds(data);

    if (deleteRefund.success === 1) {
      setMessage(deleteRefund.message);
      setOpen(true);
      const data = () =>
        setTimeout(() => {
          navigate(-1);
        }, 2000);

      data();

      return clearTimeout(data);
    }
  }

  return (
    <div>
      <CCard>
        <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color} />
        <CHeader style={{ marginLeft: '1vw' }}>
          <strong>{isEdit ? 'Edit' : 'Add'} Refund</strong>
        </CHeader>

        <CCardBody style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
          {/* <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}> */}
          <div style={{ width: '100%', marginRight: '3%', marginTop: '2vh' }}>
            <CRow style={{ width: '100%' }}>
              <CCol xs={3}>
                <CFormLabel>
                  Booth{' '}
                  <span>
                    <CBadge color="warning">Required</CBadge>
                  </span>{' '}
                </CFormLabel>
              </CCol>
              <CCol xs={9}>
                <Select
                  placeholder="Pilih Cabang"
                  value={selectedBooth}
                  options={boothOptions}
                  onChange={(e) => {
                    setSelectedBooth(e);
                  }}
                  isDisabled={false}
                />
              </CCol>
            </CRow>
          </div>
          <div style={{ width: '100%', marginRight: '3%', marginTop: '2vh' }}>
            <CRow style={{ width: '100%' }}>
              <CCol xs={3}>
                <CFormLabel>
                  Transaction Date{' '}
                  <span>
                    <CBadge color="warning">Required</CBadge>
                  </span>{' '}
                </CFormLabel>
              </CCol>
              <CCol xs={9}>
                <CFormInput
                  style={{ width: '100%' }}
                  value={transactionDate}
                  type="date"
                  onChange={(e) => {
                    setTransactionDate(e.target.value);
                  }}
                />
              </CCol>
            </CRow>
          </div>
          <div style={{ width: '100%', marginRight: '3%', marginTop: '2vh' }}>
            <CRow style={{ width: '100%' }}>
              <CCol xs={3}>
                <CFormLabel>
                  Refund Date{' '}
                  <span>
                    <CBadge color="warning">Required</CBadge>
                  </span>{' '}
                </CFormLabel>
              </CCol>
              <CCol xs={9}>
                <CFormInput
                  style={{ width: '100%' }}
                  value={refundDate}
                  type="date"
                  onChange={(e) => {
                    setRefundDate(e.target.value);
                  }}
                />
              </CCol>
            </CRow>
          </div>
          <div style={{ width: '100%', marginRight: '3%', marginTop: '2vh' }}>
            <CRow style={{ width: '100%' }}>
              <CCol xs={3}>
                <CFormLabel>
                  Amount{' '}
                  <span>
                    <CBadge color="warning">Required</CBadge>
                  </span>{' '}
                </CFormLabel>
              </CCol>
              <CCol xs={9}>
                <CFormInput
                  style={{ width: '100%' }}
                  value={amount}
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    setAmount(e.target.value);
                  }}
                />
              </CCol>
            </CRow>
          </div>
          <div style={{ width: '100%', marginRight: '3%', marginTop: '2vh' }}>
            <CRow style={{ width: '100%' }}>
              <CCol xs={3}>
                <CFormLabel>
                  Notes{' '}
                  <span>
                    <CBadge color="warning">Required</CBadge>
                  </span>{' '}
                </CFormLabel>
              </CCol>
              <CCol xs={9}>
                <CFormInput
                  style={{ width: '100%' }}
                  value={notes}
                  type="text"
                  onChange={(e) => {
                    setNotes(e.target.value);
                  }}
                />
              </CCol>
            </CRow>
          </div>
          {/* </CForm> */}
        </CCardBody>
        <CCardFooter style={{ textAlign: 'right', width: '100%' }}>
          <CButton
            style={{ backgroundColor: 'green', border: 'none', marginRight: '1vw', marginLeft: '1vw' }}
            onClick={() => {
              handleOnClick(!isEdit ? 'Save' : 'Update');
            }}
          >
            {!isEdit ? 'Save' : 'Update'} Data
          </CButton>
          {/* <CButton style={{backgroundColor: "green", border:"none", marginRight:"1vw", marginLeft:"1vw"}}  onClick={testSnackBar}>{!isEdit ? "Add" : "Save"} Data</CButton> */}
          {!isEdit ? (
            <></>
          ) : (
            <CButton
              style={{ backgroundColor: 'red', border: 'none' }}
              onClick={() => {
                handleDelete();
              }}
            >
              Delete Data
            </CButton>
          )}
        </CCardFooter>
      </CCard>
    </div>
  );
}
